import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/system/Container';
import Master from 'front/MasterAdmin';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { hasErrors } from '../../../common/enums';
import { Franchise } from '../../../common/models/franchise';
import { adminSlice } from '../../../common/store/admin';
import { franchiseSlice } from '../../../common/store/franchises';
import { AppState, appStore, franchiseSelector } from '../../../common/store/store';
import { postData } from '../../api';

const FranchiseItem = (props: { franchise: Franchise; }) => {

    const navigate = useNavigate();

    return <ListItemButton onClick={() => { navigate('/admin/franchise/' + props.franchise.id); }}>
        <ListItemText primary={props.franchise.name} secondary={'Contact : ' + (props.franchise.contactName ?? 'aucun')} />
    </ListItemButton>;
};

export const Franchises = () => {

    const franchises = useSelector((state: AppState) => franchiseSelector.selectAll(state));

    const newFranchise = useSelector((state: AppState) => state.admin.newFranchise);
    const [err, setErr] = React.useState<ResponseError[] | undefined>();

    const onAjouterClick = async () => {
        const response = await postData<Franchise>('franchises', newFranchise);
        if (hasErrors(response)) {
            setErr(response);
        } else {
            setErr(undefined);
            appStore.dispatch(franchiseSlice.actions.addOne(response));
            appStore.dispatch(adminSlice.actions.updateNewFranchise({ name: '' }));

        }
    };

    return <Master><Container maxWidth={false}><Typography variant={'h1'}>Franchises</Typography>
        <List>
            {franchises.map(ae => <FranchiseItem key={ae.id} franchise={ae} />)}
        </List>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ flexGrow: 1 }}>
                <TextField
                    fullWidth
                    value={newFranchise.name}
                    onChange={(event) => {
                        appStore.dispatch(adminSlice.actions.updateNewFranchise({ name: event.target.value }));
                    }}
                    type='text'
                    required
                    size='small'
                    sx={{ width: '100%' }}
                    error={!!err?.find(p => p.param == 'name')}
                    helperText={err?.find(p => p.param == 'name')?.msg}
                    placeholder='Nom de la franchise' />
            </Box>
            <Box>
                <Button
                    disabled={newFranchise.name == ''}
                    size='small'
                    variant='contained'
                    onClick={onAjouterClick}>Ajouter</Button>
            </Box>
        </Box>
    </Container></Master>
        ;
};
